(function () {
  var KEY = 'ep_wishlist';

  function getList() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode etc.) - fail silently */
    }
  }

  function isSaved(handle) {
    return getList().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveList(list);
    updateButtons();
    updateCount();
    document.dispatchEvent(new CustomEvent('ep-wishlist:change', { detail: { list: list } }));
    return list.indexOf(handle) !== -1;
  }

  function updateButtons() {
    var list = getList();
    var buttons = document.querySelectorAll('[data-ep-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var handle = btn.getAttribute('data-product-handle');
      var saved = list.indexOf(handle) !== -1;
      var current = btn.getAttribute('aria-pressed');
      var next = saved ? 'true' : 'false';
      if (current !== next) {
        btn.setAttribute('aria-pressed', next);
      }
    }
  }

  function updateCount() {
    var count = getList().length;
    var el = document.getElementById('ep-wishlist-count');
    if (!el) return;
    el.textContent = String(count);
    el.hidden = count === 0;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ep-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggle(handle);
  });

  var rafPending = false;
  function scheduleSync() {
    if (rafPending) return;
    rafPending = true;
    var run = function () {
      rafPending = false;
      updateButtons();
      updateCount();
    };
    if (window.requestAnimationFrame) {
      requestAnimationFrame(run);
    } else {
      setTimeout(run, 16);
    }
  }

  function startObserver() {
    if (!window.MutationObserver || !document.body) return;
    var observer = new MutationObserver(scheduleSync);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    updateButtons();
    updateCount();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.epWishlist = {
    getList: getList,
    isSaved: isSaved,
    toggle: toggle,
    updateButtons: updateButtons,
    updateCount: updateCount
  };
})();
